'use client';

import { useRouter } from "next/navigation";
import { useLenis } from "lenis/react";
import { RouterName } from "@/lib/enum/RouterEnum";
import './textHeader.scss'

const TextHeader = () => {
  const router = useRouter();
  const lenis = useLenis();

  const _goHome = () => {
    lenis?.scrollTo(0, { immediate: true });
    if (typeof window !== 'undefined') window.scrollTo(0, 0);
    router.push(RouterName.dashboard);
  };

  return (
    <div id='image-content-home' className={'image-content-home'} onClick={_goHome}>
      <img 
        src="/assets/gif/TOL_512.webp" 
        alt="The Other Lab" 
        width={512}
        height={512}
        style={{ width: '100%', height: 'auto' }} 
      />
    </div>
  )
}

export default TextHeader;
